<template>
  <router-view v-if="user" :user.sync="user" />
  <span v-else />
</template>

<script>

import $api from '../../../libs/OAuth2/services/api';

export default {
  name: 'user-frame',
  data () {
    return {
      user: null,
    };
  },
  beforeRouteEnter (to, from, next) {
    const id = to.params?.id;
    if (!id) {
      return next(from);
    }

    $api.fetchOperator(id)
      .then(res => res.data)
      .then(data => {
        if (!data) {
          return next(from);
        }

        next(vm => {
          vm.user = data;
        });
      })
      .catch(() => next(from))
    ;
  },
};

</script>
